export enum ESubscriptionStatus {
  NOT_STARTED = 1, // Не начат
  IN_PROGRESS = 2, // В процессе выполнения
  DONE = 3, // Выполнен корректно
  FAILED = 4, // Выполнен некорректно
  AWAITING_CONFIRMATION = 5, // Ожидает подтверждения
  AWAITING_REPEAT_PASS = 6, // Ожидает перепрохождения
  AWAITING_CONTINUE = 7, // Ожидает продолжения
  AWAITING_COMPLETION = 8, // Ожидает завершения
  ARCHIVED = 9 // Архивировано
}

export enum ESubscriptionProgressStatus {
  NOT_STARTED = 1, // Не начат
  SLIGHTLY_BEHIND = 2, // Немного отстает
  FAR_BEHIND = 3, // Сильно отстает
  MAKE_PROGRESS = 4, // Успевает
  DONE = 5 // Выполнен
}
